// extracted by mini-css-extract-plugin
export default {"container":"mZ-z","heading":"nZ-z","links":"oZ-z","copy":"pZ-z","subCopy":"qZ-z","linksLeft":"rZ-z","linksCenter":"sZ-z","linksRight":"tZ-z","link":"uZ-z","onlyLink":"vZ-z"};